module.exports = __webpack_public_path__ + "static/Roasted-Capcicum-&-Almond-4517936187ba46fc9572fa8ca25d6e09.png";